import createIcon from '../../createIcon';

/**
 * @component @name Atm
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCA5VjEwLjVIMTAuMjVWMTVIMTEuNzVWMTAuNUgxNFY5SDhaTTYgOUgzQzIuNDUgOSAyIDkuNDUgMiAxMFYxNUgzLjVWMTMuNUg1LjVWMTVIN1YxMEM3IDkuNDUgNi41NSA5IDYgOVpNNS41IDEySDMuNVYxMC41SDUuNVYxMlpNMjEgOUgxNi41QzE1Ljk1IDkgMTUuNSA5LjQ1IDE1LjUgMTBWMTVIMTdWMTAuNUgxOFYxNEgxOS41VjEwLjQ5SDIwLjVWMTVIMjJWMTBDMjIgOS40NSAyMS41NSA5IDIxIDlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Atm = createIcon('Atm', [
  [
    'path',
    {
      d: 'M8 9V10.5H10.25V15H11.75V10.5H14V9H8ZM6 9H3C2.45 9 2 9.45 2 10V15H3.5V13.5H5.5V15H7V10C7 9.45 6.55 9 6 9ZM5.5 12H3.5V10.5H5.5V12ZM21 9H16.5C15.95 9 15.5 9.45 15.5 10V15H17V10.5H18V14H19.5V10.49H20.5V15H22V10C22 9.45 21.55 9 21 9Z',
      key: '7vpg51',
    },
  ],
]);

export default Atm;
